module.exports = __webpack_public_path__ + "static/media/BCP.dcdbccd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/payment-method/BCP.png
// module id = 1984
// module chunks = 0